export var getSiteContextName = function (siteContext) {
    return "".concat(siteContext.charAt(0).toUpperCase()).concat(siteContext.slice(1));
};
